import { render, staticRenderFns } from "./CDActivityVolumeChart.vue?vue&type=template&id=18fddf6e&scoped=true"
import script from "./CDActivityVolumeChart.vue?vue&type=script&lang=ts"
export * from "./CDActivityVolumeChart.vue?vue&type=script&lang=ts"
import style0 from "./CDActivityVolumeChart.vue?vue&type=style&index=0&id=18fddf6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fddf6e",
  null
  
)

export default component.exports